import React, { useContext, useMemo } from "react";
import { useStyles } from "../../RCACompliance/RCACompliance.styles";
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import ComplianceBar from "../../components/ComplianceBar";
import { RCAAPComplianceContext } from "contexts/RCAAPComplianceContext/RCAAPComplianceContext";
import moment from "moment";
import { RCAAPComplianceEntity } from "entities/RCA/RCAAPComplianceEntity/RCAAPComplianceEntity";
import { ComplianceBarReferences } from "../../components/ComplianceBar/ComplianceBarReferences.view";

const APComplianceWholeMill = () => {
    const classes = useStyles();
    const { t } = useTranslation();
    const { filters } = useContext(RCAAPComplianceContext);
    const argsFilters = useMemo(
        () => ({
            date: moment().subtract(Number(filters.periodOption), "day").startOf("day").toISOString(),
            meetingTypeIds: filters.meetingTypeIds,
            totalMeetingTypes: filters.totalMeetingTypes,
        }),
        [filters],
    );
    const { actionPlanComplianceByMill } = RCAAPComplianceEntity.GetActionPlanComplianceByMill(argsFilters);

    const barData = useMemo(
        () =>
            actionPlanComplianceByMill.map((actionPlan) => ({
                completedOnTimeAmount: actionPlan.completed_on_time,
                pendingAmount: actionPlan.pending,
                completedLateAmount: actionPlan.completed_late,
                pendingLateAmount: actionPlan.pending_late,
                total: actionPlan.total_action_plans_by_period,
            })),
        [actionPlanComplianceByMill],
    );

    return (
        <div className={classes.card}>
            <div className={classes.cardHeader}>
                <Typography variant="rcaTitle" className={classes.cardTitle}>
                    {t("rca.compliance.ap_compliance.whole_mill.title")}
                </Typography>
            </div>
            <div className={classes.cardBody}>
                <ComplianceBar data={barData} />
                {barData.length > 0 && <ComplianceBarReferences />}
            </div>
        </div>
    );
};

export default APComplianceWholeMill;
